import { Route, Routes } from "react-router-dom";
import "./App.css";
import Home from "./components/Home";
import NoContent from "./components/NoContent";
import ErrorPage from "./pages/ErrorPage";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
        {/* <Route
          path="/withdrawal"
          element={<NoContent outletTitle={"Withdraw"} />}
        /> */}
        <Route
          path="/account"
          element={<NoContent outletTitle={"My Account"} />}
        />
        <Route
          path="/history"
          element={<NoContent outletTitle={"History"} />}
        />
        <Route
          path="/notifications"
          element={<NoContent outletTitle={"Notification"} />}
        />
        <Route
          path="/settings"
          element={<NoContent outletTitle={"Settings"} />}
        />
        <Route path="/help" element={<NoContent outletTitle={"Help"} />} />
        {/* <Route path="*" element={<ErrorPage />} /> */}

        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </div>
  );
}

export default App;
